import templateUrl from "emun.activity/activity-prompt.htm";
import ActivityPromptController from "emun.activity/activity-prompt.controller";
import open from "webmodals/open";

export default {
  open: options =>
    open({
      size: "sm",
      // placement: 'right',
      //backdrop: false,
      templateUrl,
      resolve: {
        options: () => options
      },
      bindToController: true,
      controller: ActivityPromptController,
      controllerAs: "$ctrl",
      ...(options || {}).modal
    }).result
};
